'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var Typography = require('../../Base/Typography/Typography.js');
require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

const TextButton = (_a)=>{
    var { value, isListOpen, disabled, className } = _a, rest = _tslib.__rest(_a, [
        "value",
        "isListOpen",
        "disabled",
        "className"
    ]);
    return jsxRuntime.jsxs("button", Object.assign({
        type: "button",
        className: tailwindMerge.twMerge('flex items-center gap-2 outline-none', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        disabled: disabled
    }, rest, {
        children: [
            jsxRuntime.jsx(Typography, {
                variant: "body1",
                className: tailwindMerge.twMerge('text-w-gray-600', disabled && 'text-w-gray-300'),
                children: value
            }),
            jsxRuntime.jsx("span", {
                className: tailwindMerge.twJoin('transition-transform duration-300', isListOpen && 'rotate-180'),
                children: jsxRuntime.jsx(SystemIcon, {
                    name: "medium_arrow_down",
                    className: tailwindMerge.twMerge('text-w-gray-600', disabled && 'text-w-gray-300')
                })
            })
        ]
    }));
};

exports.TextButton = TextButton;
